export const partnersStatisticTypes = [
  { value: 'amount', label: 'Точки продажу ₴', description: 'Відображається заробіток у грн.' },
  { value: 'count', label: 'Точки продажу ШТ', description: 'Відображається кількість проданих шт.' },
  { value: 'earnings', label: 'Комісійні винагороди точок продажу ₴', description: 'Відображається заробіток у грн.' },
];
